import { render, staticRenderFns } from "./ServiceChooseWidget.vue?vue&type=template&id=af2050be&scoped=true&"
import script from "./ServiceChooseWidget.vue?vue&type=script&lang=js&"
export * from "./ServiceChooseWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2050be",
  null
  
)

export default component.exports